import { render, staticRenderFns } from "./ArticleImport.vue?vue&type=template&id=03c71d57&"
import script from "./ArticleImport.vue?vue&type=script&lang=js&"
export * from "./ArticleImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports